module.exports = __webpack_public_path__ + "media/andenes/automatic_dim_ramp-6ccd39a3.webp";